import { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

type GraphicAreaHeaderProps = HTMLAttributes<HTMLDivElement>

export function GraphicAreaHeader(props: GraphicAreaHeaderProps) {
  return (
    <div {...props} className={twMerge(['mb-6 pr-9 mr-9', props.className])} />
  )
}
